module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<dl class=\'stepped zero\'>\n    <dt>ID</dt>\n    <dd>' +
((__t = ( id )) == null ? '' : __t) +
'</dd>\n    <dt>' +
((__t = ( i18next.t('glossary.configuration') )) == null ? '' : __t) +
'</dt>\n    <dd>' +
((__t = ( configurationName )) == null ? '' : __t) +
'</dd>\n    <dt>' +
((__t = ( i18next.t('common.name') )) == null ? '' : __t) +
'</dt>\n    <dd>' +
((__t = ( name )) == null ? '' : __t) +
'</dd>\n    <dt>' +
((__t = ( i18next.t('glossary.site') )) == null ? '' : __t) +
'</dt>\n    <dd><a href="' +
((__t = ( site.nodeUrl() )) == null ? '' : __t) +
'">' +
((__t = ( site.get('name') )) == null ? '' : __t) +
'</a></dd>\n    <dt>' +
((__t = ( i18next.t('integrations.integration_indicators') )) == null ? '' : __t) +
'</dt>\n    ';
 integrationIndicators.forEach(function(indicator) { ;
__p += '\n        <dd><a href="' +
((__t = ( indicator.nodeUrl() )) == null ? '' : __t) +
'">' +
((__t = ( indicator.get('name') )) == null ? '' : __t) +
'</a></dd>\n    ';
 }) ;
__p += '\n    <dt>' +
((__t = ( i18next.t('common.reference') )) == null ? '' : __t) +
'</dt>\n    <dd>' +
((__t = ( reference )) == null ? '' : __t) +
'</dd>\n    <dt>' +
((__t = ( i18next.t('integrations.last_run_at') )) == null ? '' : __t) +
'</dt>\n    <dd>' +
((__t = ( last_run_at ? WiseMetering.utils.formatDate(last_run_at) : '-' )) == null ? '' : __t) +
'</dd>\n    <dt>' +
((__t = ( i18next.t('common.creation') )) == null ? '' : __t) +
'</dt>\n    <dd>' +
((__t = ( WiseMetering.utils.formatDate(created_at) )) == null ? '' : __t) +
' - ' +
((__t = ( WiseMetering.utils.getUserName(created_by) )) == null ? '' : __t) +
'</dd>\n    <dt>' +
((__t = ( i18next.t('glossary.last_change') )) == null ? '' : __t) +
'</dt>\n    <dd>' +
((__t = ( WiseMetering.utils.formatDate(updated_at) )) == null ? '' : __t) +
' - ' +
((__t = ( WiseMetering.utils.getUserName(updated_by) )) == null ? '' : __t) +
'</dd>\n</dl>\n';

}
return __p
}